import { unsafeCSS } from "lit";
import { property } from "lit/decorators.js";
import { watch } from "../../utilities/watch.js";
import { LeafElement } from "../leaf-element.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host {\n  background: var(--leafdcws-backdrop-overlay);\n  box-sizing: border-box;\n  display: none;\n  height: 100%;\n  left: 0;\n  min-height: 100dvh;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: var(--leafdcws-z-index-200);\n}\n\n:host([active]) {\n  display: block;\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _LeafBackdrop = class _LeafBackdrop extends LeafElement {
  constructor() {
    super(...arguments);
    this.active = false;
  }
  toggleBackdrop() {
    document.body.classList.toggle("backdrop-active", this.active);
    this.emit(`leaf:${this.active ? "show" : "hide"}`);
  }
};
_LeafBackdrop.styles = unsafeCSS(styles);
let LeafBackdrop = _LeafBackdrop;
__decorateClass([
  property({ type: Boolean, reflect: true, attribute: "active" })
], LeafBackdrop.prototype, "active", 2);
__decorateClass([
  watch("active")
], LeafBackdrop.prototype, "toggleBackdrop", 1);
export {
  LeafBackdrop
};
//# sourceMappingURL=backdrop.component.js.map
